import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from '../presentation/components/confirm-dialog/confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  constructor(private modalService: NgbModal) { }

  confirm(title: string, message: string): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      //size: 'sm',
      centered: true,
      backdrop: 'static', // Prevents closing when clicking outside
      keyboard: false     // Prevents closing when pressing the ESC key
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;

    return modalRef.result
      .then((result) => {
        // result will be 'true' if the confirm button was clicked
        return result === true;
      })
      .catch(() => {
        // Handles backdrop clicks (if allowed) or dismiss() calls
        return false;
      });
  }
}
